var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Drawer, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { finalInspectorListsUrl } from '../../api/url';
import DrawerHeader from '../../components/atoms/DrawerHeader';
import { EMenuFeature, EMenuNames, EParentModuleName, LOCAL_STORAGE_KEYS } from '../../constants';
import { setDocDataUpdated } from '../../redux/commonSlice';
import { setState } from '../../redux/crudSlice';
import { useAppSelector } from '../../store/hooks';
import { getLocalStorageItem } from '../../utils/storageHelper';
import { getCTAList } from '../../utils/utils';
import List from '../commonViews/list/list';
import AssignFinalInspectorPopup from '../jobCard/assignFinalInspectorPopup';
import ServiceEstimateDrawer from '../jobCard/serviceEstimateDrawer';
import TaskSummary from '../jobCard/taskSummary';
import useRbacController from '../../builderPackage/rbac/useRbacController';
var listVariants = ["My Job Card", "All Job Card"];
var FinalInspector = function () {
    var _getCTAList;
    var _a = useState({}), clickIndexItem = _a[0], setClickIndexItem = _a[1];
    var _b = useAppSelector(function (state) { return state.crud; }), getFinalInspectorList = _b.getFinalInspectorList, isLoadinggetFinalInspectorList = _b.isLoadinggetFinalInspectorList;
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _c = useState(false), openTaskSummery = _c[0], setOpenTaskSummery = _c[1];
    var _d = useState(false), openServiceEstimate = _d[0], setOpenServiceEstimate = _d[1];
    var _e = useState(""), assignValue = _e[0], setAssignValue = _e[1];
    var _f = useState(false), isAssignFIModalOpen = _f[0], setIsAssignFIModalOpen = _f[1];
    var rbacControl = useRbacController('/FinalInspection');
    var finalInspectionFeatures = (_getCTAList = getCTAList(storedAllMenuFeatures, (selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === "ServiceAdvisor" ? EMenuNames.Jobcard : EMenuNames.FinalInspection)) === null || _getCTAList === void 0 ? void 0 : _getCTAList.filter(function (feature) {
        var _rbacControl$feature$;
        return Boolean(rbacControl === null || rbacControl === void 0 || (_rbacControl$feature$ = rbacControl[feature.Name]) === null || _rbacControl$feature$ === void 0 ? void 0 : _rbacControl$feature$.showInMoreMenu);
    });
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    useEffect(function () {
        dispatch(setDocDataUpdated(false));
    }, []);
    var onClickJobCardCard = function (item) {
        dispatch(setState({
            key: "filterValue",
            value: {}
        }));
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
        dispatch(setState({
            key: "FIObservation",
            value: {}
        }));
        navigate("/jobcard-details/".concat(item.JobCardId));
    };
    var handleMenusClick = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(setState({
                key: "FIObservation",
                value: {}
            }));
            if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.FiViewTaskSummary) {
                setOpenTaskSummery(function (prev) { return !prev; });
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.FiViewServiceEstimate) {
                setOpenServiceEstimate(true);
            }
            else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.ReassignFinalInspector) {
                setIsAssignFIModalOpen(true);
                setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
            }
            return [2 /*return*/];
        });
    }); };
    var onDrawerClick = function () {
        setOpenTaskSummery(function (prev) { return !prev; });
    };
    var onDrawerSEClick = function () {
        setOpenServiceEstimate(function (prev) { return !prev; });
    };
    var onViewEstimateClick = function () {
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
        onDrawerSEClick();
        navigate("/serviceEstimate-details/".concat(clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.ParentId));
    };
    var onRevisedEstimateClick = function (PreJobCardDocumentId) {
        onDrawerSEClick();
        navigate("/reviseEstimate-details/RevisedEstimate/".concat(PreJobCardDocumentId, "/").concat(clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.JobCardId)); // prejobcard doucment id
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(List, {
        isFinalInspector: true,
        getModuleList: getFinalInspectorList,
        storeModuleName: "getFinalInspectorList"
        //   pageTitle="Service estimate"
        ,
        moduleListUrl: finalInspectorListsUrl,
        listVariants: listVariants,
        menusFeatures: finalInspectionFeatures !== null && finalInspectionFeatures !== void 0 ? finalInspectionFeatures : [],
        onClickCard: onClickJobCardCard
        // onClickCreateModule={onClickCreateJC}
        ,
        handleMenusClick: handleMenusClick,
        itemData: function (item) { return setClickIndexItem(item); },
        isCreateButton: false
        // createButtonText={t('Create appointment')}
        ,
        moduleName: "JobCard",
        loadingState: isLoadinggetFinalInspectorList,
        noDataTitle: t("No Job Card Found"),
        noDataSubTitle: t("No job card created yet, Please create new job card.")
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "right",
        open: openTaskSummery,
        onClose: function () { return onDrawerClick(); },
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                width: IS_MOBILE ? '90%' : IS_TABLET ? '60%' : "35%"
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: "100%"
        },
        role: "presentation"
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(TaskSummary, {
        onCrossClick: onDrawerClick,
        id: clickIndexItem.JobCardId,
        jobCardData: clickIndexItem
    }))), /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "right",
        open: openServiceEstimate,
        onClose: function () { return onDrawerSEClick(); },
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                width: IS_MOBILE ? '90%' : IS_TABLET ? '50%' : "35%"
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: "100%"
        },
        role: "presentation"
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(ServiceEstimateDrawer, {
        estimateId: clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.ParentId,
        jobCardId: clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.JobCardId,
        Code: clickIndexItem.Code,
        parentModuleName: EParentModuleName.Jobcard,
        onCrossClick: onDrawerSEClick,
        onViewClick: onViewEstimateClick,
        onRevisedEstimateClick: onRevisedEstimateClick
    })))), isAssignFIModalOpen && /*#__PURE__*/ React.createElement(AssignFinalInspectorPopup, {
        isOpen: isAssignFIModalOpen,
        onClose: function () {
            setIsAssignFIModalOpen(false);
        },
        data: clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.JobCardNo,
        jobCardData: clickIndexItem,
        assignValue: assignValue
    }));
};
export default FinalInspector;
